// Vendor Libs
import React from 'react';

// Components
import FlexDashboard from '../components-core/flex-dashboard';
import EditShelf from './edit-shelf';

// Configs
import getDashboardConfig from '../configs/flex-dashboard-config';

const dashboardConfig = {
    layout: {
        type: 'row',
        children: [
            {
                type: 'row',
                children: [
                    {
                        type: 'tabset',
                        children: [
                            {
                                id: 'EDITSHELF',
                                type: 'tab',
                                name: '',
                                component: EditShelf,
                            },
                        ],
                    },
                ],
            },
        ],
    },
};

const ShelfDetailDashboard = () => (
    <FlexDashboard dashboardConfig={getDashboardConfig(dashboardConfig)} dashboardName="shelfItems" />
);

export default ShelfDetailDashboard;
